import { createStandaloneToast } from '@chakra-ui/react';
import FormData from 'form-data';
import requestChangePassword from 'helpers/requestChangePassword';
import { getStorage, STORAGE_KEY } from 'helpers/storage';
import { ENDPOINT } from 'services/configs/endpoint.constant';
import { UserService } from 'services/user/user.service';
import { call, put, takeEvery } from 'typed-redux-saga';
import { ChangePasswordAction, DeleteUserAction, EditUserAction } from 'types/actions/userManage';

import { userManageAction } from '../actions';
import { userManageConstant } from '../actionTypes';
import { allowedRoles } from '../helpers/lib';

const { toast } = createStandaloneToast();

const fetchListUserData = function* () {
  const data = yield* call(() => {
    return UserService.getListUsers();
  });
  const listRoles = yield* call(() => {
    return UserService.getListRoles();
  });

  yield* put(userManageAction.updateListRoles(listRoles));
  yield* put(userManageAction.updateStateListUser(data));
};

const createUserData = function* ({ payload }: EditUserAction) {
  const data = yield* call(() => {
    return UserService.createUser({
      email: payload.email,
      role: payload.role,
      first_name: payload.firstName,
      last_name: payload.lastName,
      locale: payload.locale,
    });
  });
  if (data?.id && allowedRoles.includes(data?.role)) {
    toast({
      title: 'Create user successfully!',
      status: 'success',
      isClosable: true,
      position: 'bottom-right',
    });
  }
  if ((data as any)?.error_message) {
    toast({
      title: 'Error',
      description: (data as any)?.error_message,
      status: 'error',
      isClosable: true,
      position: 'bottom-right',
    });
  }

  yield* put(userManageAction.fetchListUser());
};

const deleteUserData = function* ({ record }: DeleteUserAction) {
  const data = yield* call(() => {
    return UserService.deleteUser(record.id);
  });

  if (data === true) {
    toast({
      title: 'Delete user successfully!',
      status: 'success',
      isClosable: true,
      position: 'bottom-right',
    });
  }

  yield* put(userManageAction.fetchListUser());
};

const changePasswordSagaData = function* (action: ChangePasswordAction) {
  const data = yield* call(() => {
    const tempFormData = new FormData();
    tempFormData.append('old_password', action.payload.oldPassword);
    tempFormData.append('new_password', action.payload.newPassword);
    // tempFormData.append('totp', action.payload.totp);

    return requestChangePassword({
      method: 'PUT',
      url: ENDPOINT.CHANGE_PASSWORD(getStorage(STORAGE_KEY.ID) as string),
      data: tempFormData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  });
  if (data?.data === true) {
    toast({
      title: 'Change password successfully',
      status: 'success',
      isClosable: true,
      position: 'bottom-right',
    });
  }

  yield* put(userManageAction.updateStateChangePw());
};

const editUserData = function* (action: EditUserAction) {
  const data = yield* call(() => {
    return UserService.editUser(action.payload.id, {
      id: action.payload.id,
      email: action.payload.email,
      role: action.payload.role,
      first_name: action.payload.firstName,
      last_name: action.payload.lastName,
      organization_name: action.payload.organizationName,
      locale: action.payload.locale,
    });
  });
  if (data) {
    toast({
      title: 'Change user role successfully!',
      status: 'success',
      isClosable: true,
      duration: 1000,
      position: 'bottom-right',
    });
  }
  yield* put(userManageAction.fetchListUser());
};

export const watchEditUser = function* () {
  yield* takeEvery(userManageConstant.EDIT_USER, editUserData);
};

export const watchChangePassword = function* () {
  yield* takeEvery(userManageConstant.CHANGE_PW, changePasswordSagaData);
};

export const watchFetchListUser = function* () {
  yield* takeEvery(userManageConstant.FETCH_LIST_USER, fetchListUserData);
};

export const watchCreateUser = function* () {
  yield* takeEvery(userManageConstant.CREATE_USER, createUserData);
};

export const watchDeleteUser = function* () {
  yield* takeEvery(userManageConstant.DELETE_USER, deleteUserData);
};
